import React from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";

import Tabs from "../../atoms/Tabs";
import { GIFT_LANDING_TABS, SEND_GIFT_TABS } from "../../../helpers/navbarProcessor";
import URL_PATTERNS from "../../../urls";
import { I18N_NAMESPACES } from "../../../helpers/constants";

function GiftTabs() {
  const { t } = useTranslation([I18N_NAMESPACES.GIFTS]);

  const history = useHistory();
  const isSendGiftPage = history?.location?.pathname === URL_PATTERNS.SEND_GIFT;
  const tabs = isSendGiftPage ? SEND_GIFT_TABS : GIFT_LANDING_TABS;

  const translatedTabs = tabs.map((tab) => ({
    url: tab.url,
    text: t(tab.i18nKey),
  }));

  return <Tabs tabs={translatedTabs} />;
}

export default GiftTabs;
